import { Component } from '@angular/core';

@Component({
    selector: 'app-main-footer',
    templateUrl: './main-footer.component.html',
    styleUrls: ['./main-footer.component.scss'],
    standalone: false
})
export class MainFooterComponent {

}
